import { Injectable } from '@angular/core';
import { CurrencyInfo } from './currency.service';

/**
 * Display currency chosen on the quotation / auction tab (multi-currency dropdown).
 * Used app-wide (e.g. bid accept/reject toasts) so amounts match the vendor's selected quote currency.
 */
@Injectable({ providedIn: 'root' })
export class VendorQuotationCurrencyContextService {
    private readonly byEventId = new Map<string, CurrencyInfo>();

    setEventDisplayCurrency(eventId: string | null | undefined, info: CurrencyInfo | null | undefined): void {
        const id = eventId?.toString()?.trim();
        if (!id) {
            return;
        }
        if (!info?.code?.trim()) {
            this.byEventId.delete(id);
            return;
        }
        this.byEventId.set(id, {
            code: info.code.trim().toUpperCase(),
            symbol: info.symbol ?? '',
            name: info.name,
        });
    }

    getEventDisplayCurrency(eventId: string | null | undefined): CurrencyInfo | null {
        const id = eventId?.toString()?.trim();
        if (!id) {
            return null;
        }
        const info = this.byEventId.get(id);
        return info ? { ...info } : null;
    }

    clearEvent(eventId: string | null | undefined): void {
        const id = eventId?.toString()?.trim();
        if (!id) {
            return;
        }
        this.byEventId.delete(id);
    }
}
